// @ts-nocheck



import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from '../../../lib/routerAdapter';
import { navigate } from '../../../lib/routerAdapter';
import qs from 'query-string';

import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';








import {
  osagoCalculationApi,
  osagoCalculationYearApi,
  vehicleApi } from

'./../../../lib/api';
import {
  getListInitialState,
  applyMaskToValue,
  getValueObject } from
'./../../../lib/helpers';
import { vehicleGroups, vehicleTypes, ownerTypes } from './../../../lib/enum';


import { Popconfirm, Icon, Operations, Table } from './../../../components/ui';
import { Section, SectionTitle, Footer } from './../../../components/layout';

import Header from './../../../components/layout/Header';
import { VehicleStatus } from './../../../components';
import VehicleFilter from

'./../../Vehicles/Filter';
import {
  setSelectedVehicles,
  clearData,
  deleteOsagoCalculation,
  addFilterOsagoCalculation,
  addUnselectOsagoCalculation,
  setFilterOsagoCalculation,
  setUnselectOsagoCalculation } from
'./../../../ducks/osagoCalculation';
import { notificationLoading } from './../../../components/Notifications';
import { formatLicensePlateMask } from '../../../components/inputs/masked-inputs/LicensePlateInput';

const StyledIcon = styled(Icon).withConfig({ displayName: "ListForm__StyledIcon", componentId: "sc-4z5i3q-0" })(["margin:0 5px;color:#1890ff;cursor:pointer;"]);





const StyledDiv = styled.div.withConfig({ displayName: "ListForm__StyledDiv", componentId: "sc-4z5i3q-1" })(["padding:10px;"]);



const { TextArea } = Input;

















// ListState<OsagoCalculation>






export class OsagoCalculationsList extends Component {
  state = {
    vehicles: {
      ...getListInitialState()
    },
    comment: null,
    year: new Date().getFullYear()
  };

  columns = [
  {
    title: 'Статус',
    dataIndex: 'status',
    sorter: true,
    render: (status) => <VehicleStatus status={status} />
  },
  {
    title: 'Гос. номер',
    sorter: true,
    dataIndex: 'licensePlate',
    render: (licensePlate) =>
    licensePlate && applyMaskToValue(licensePlate, formatLicensePlateMask)
  },
  {
    title: 'Год выпуска',
    sorter: true,
    dataIndex: 'yearIssued'
  },
  {
    title: 'Марка',
    sorter: true,
    sorterKey: 'vehicleModel.brand.name',
    dataIndex: 'vehicleModel.brandName'
  },
  {
    title: 'Модель',
    sorter: true,
    dataIndex: 'vehicleModel.name'
  },
  {
    title: 'Тип',
    dataIndex: 'vehicleModel',
    sorter: true,
    render: (vehicleModel) =>
    vehicleModel && vehicleTypes[vehicleModel.type]
  },
  {
    title: 'Подразделение',
    sorter: true,
    dataIndex: 'orgUnitName',
    sorterKey: 'node.name',
    width: 400,
    breakByWidth: true
  }];


  osagoCalculationColumns = [
  {
    title: 'Тип/Модель',
    dataIndex: 'vehicleModel',
    render: (vehicleModel, record) => {
      if (vehicleModel) {
        return [vehicleModel.brandName, vehicleModel.name].join(' ').trim();
      }
      return record.vehicleType ?
      vehicleTypes[record.vehicleType] :
      vehicleGroups[record.vehicleGroup];
    }
  },
  {
    title: 'Год выпуска',
    dataIndex: 'yearIssued',
    sorter: true
  },
  {
    title: 'Мощность двигателя',
    dataIndex: 'enginePower',
    render: (enginePower, record) =>
    enginePower ?
    enginePower :
    getValueObject(record, 'vehicleModel.enginePower')
  },
  {
    title: 'Кол-во пассажирских мест',
    dataIndex: 'seatsCount',
    render: (seatsCount, record) => {
      if (!!seatsCount) {
        return `${seatsCount} шт`;
      }
      const passengerSeatsNumber = getValueObject(
        record,
        'vehicleModel.passengerSeatsNumber'
      );
      return passengerSeatsNumber ? `${passengerSeatsNumber} шт` : null;
    }
  },
  {
    title: 'Максимально разрешенная масса',
    dataIndex: 'maxWeight',
    render: (maxWeight, record) => {
      if (!!maxWeight) {
        return `${maxWeight} кг`;
      }
      const maximumAuthorizedMass = getValueObject(
        record,
        'vehicleModel.maximumAuthorizedMass'
      );
      return maximumAuthorizedMass ? `${maximumAuthorizedMass} кг` : null;
    }
  },
  {
    title: '',
    width: '30px',
    render: (record) =>
    <Operations>
          <Popconfirm
        title="Вы действительно хотите удалить?"
        okText="Да"
        cancelText="Нет"
        // $FlowFixMe поставил намеренно, т.к. id всегда задается в этом компоненте строкой
        onConfirm={() => this.props.deleteOsagoCalculation(record.id)}>

            <StyledIcon type="x" />
          </Popconfirm>
        </Operations>

  }];


  fetchVehicles = async (
  page = 1,
  params = {}) =>
  {
    try {
      const { filter } = this.props;
      this.updateVehicleState({
        loading: true
      });
      const { data, totalCount } = await vehicleApi.fetchVehicles({
        ...filter,
        page,
        'vehicleModel.osagoNeeded': true,
        ownerType: ownerTypes.self,
        ...params
      });
      this.updateVehicleState({
        data,
        totalCount,
        page
      });
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err && err.message
      });
    } finally {
      this.updateVehicleState({
        loading: false
      });
    }
  };

  updateVehicleState = (data, cb) =>
  this.setState(
    (prevState) => ({
      vehicles: {
        ...prevState.vehicles,
        ...data
      }
    }),
    cb instanceof Function ? cb : () => {}
  );

  cleanVehicleFilter = async () => {
    await this.props.setFilterOsagoCalculation({});
    await this.props.setUnselectOsagoCalculation({});
    this.fetchVehicles();
  };

  applyVehicleFilter = async (filter) => {
    await this.props.setFilterOsagoCalculation(filter);
    await this.props.setUnselectOsagoCalculation({});
    this.updateVehicleState({ page: 1 }, this.fetchVehicles);
  };

  componentDidMount() {
    const { vehicles } = this.state;
    const { page, ...filter } = qs.parse(window.location.search);
    const { year } = qs.parse(this.props.location.search);
    this.props.addFilterOsagoCalculation(filter);
    this.setState(
      {
        vehicles: {
          ...vehicles
        },
        year: year ? year : new Date().getFullYear()
      },
      () => this.fetchVehicles(page)
    );
  }

  handleRowClick = (id) => {
    navigate(
      `/budget/osago-calculations/new/vehicle-free-calculation/${id}?year=${this.state.year}`
    );
  };

  goBack = async () => {
    await this.props.clearData();
    navigate('/budget/osago-calculations');
  };

  save = async () => {
    const { year } = this.state;
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      const {
        unSelectedVehicleIds,
        freeVehicleOsagoCalculations,
        employeeBranchOrgUnitId,
        filter
      } = this.props;
      const { comment } = this.state;
      const osagoCalculationYear =
      await osagoCalculationYearApi.addOsagoCalculationYear({
        year,
        comment
      });
      await osagoCalculationApi.addVehicles(
        {
          osagoCalculationYearId: osagoCalculationYear.id,
          osagoCalculationIds: Object.keys(unSelectedVehicleIds).map((id) =>
          parseInt(id)
          )
        },
        {
          ...filter,
          'vehicleModel.osagoNeeded': true,
          ownerType: ownerTypes.self
        }
      );
      await Promise.all(
        freeVehicleOsagoCalculations.map(
          ({ id, ...osagoCalculation }) =>
          osagoCalculationApi.addOsagoCalculation({
            ...osagoCalculation,
            osagoCalculationYearId: osagoCalculationYear.id,
            orgUnitId: employeeBranchOrgUnitId
          })
        )
      );
      notification.success({
        message: 'Успешно',
        description: 'Расчеты созданы'
      });

      this.goBack();
    } catch (err) {
      notification.error({
        message: 'Ошибка',
        description: err && err.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  onSelect = (record, selected) => {
    let { unSelectedVehicleIds } = this.props;
    if (!selected) {
      unSelectedVehicleIds[record['id']] = record;
    } else {
      delete unSelectedVehicleIds[record['id']];
    }
    this.props.addUnselectOsagoCalculation(unSelectedVehicleIds);
  };

  onSelectAll = (selected, selectedRecord) => {
    let { unSelectedVehicleIds } = this.props;
    let { vehicles } = this.state;
    if (selected) {
      selectedRecord.forEach(
        (item) =>
        unSelectedVehicleIds[item['id']] &&
        delete unSelectedVehicleIds[item['id']]
      );
    } else {
      vehicles.data.forEach(
        (item) => unSelectedVehicleIds[item['id']] = item
      );
    }
    this.props.addUnselectOsagoCalculation(unSelectedVehicleIds);
  };

  setSelectedRowKeys = () => {
    const { unSelectedVehicleIds } = this.props;
    const { vehicles } = this.state;
    // $FlowFixMe
    return vehicles.data.
    map((item, index) => {
      if (unSelectedVehicleIds[item.id]) {
        return false;
      }
      return index;
    }).
    filter((item) => item !== false);
  };

  render() {
    const { freeVehicleOsagoCalculations, filter } = this.props;
    const { vehicles, comment, year } = this.state;
    const selectedVehicleIds = this.setSelectedRowKeys();

    return (
      <>
        <Header
          left={
          <h1>Расчет потребностей ОСАГО {year ? `на ${year} год` : null}</h1>
          } />

        <Section>
          <SectionTitle divider>Текущие ТС</SectionTitle>
          <VehicleFilter
            filter={filter}
            cleanFilter={this.cleanVehicleFilter}
            applyFilter={this.applyVehicleFilter} />

          <Table
            columns={this.columns}
            rowSelection={{
              selectedRowKeys: selectedVehicleIds,
              onSelect: this.onSelect,
              onSelectAll: this.onSelectAll
            }}
            fetch={this.fetchVehicles}
            data={vehicles.data}
            loading={vehicles.loading}
            pagination={{
              page: vehicles.page,
              totalCount: vehicles.totalCount,
              pageSize: vehicles.pageSize
            }} />

        </Section>
        <Section>
          <SectionTitle
            divider
            suffix={
            <Link
              to={`/budget/osago-calculations/new/vehicle-free-calculation?year=${year}`}>

                <Button type="primary" data-cy="add">
                  Добавить новый ТС
                </Button>
              </Link>
            }>

            Планируемые ТС
          </SectionTitle>
          {/* <Table
             onRow={(record) => ({
               onClick: () => this.handleRowClick(record.id),
             })}
             rowKey="id"
             columns={this.osagoCalculationColumns}
             data={freeVehicleOsagoCalculations.map((item) => ({
               ...item,
               key: item.id,
             }))} */}
        </Section>
        <Section>
          <SectionTitle divider>Комментарий</SectionTitle>
          <StyledDiv>
            <TextArea
              value={comment || ''}
              onChange={(e) => this.setState({ comment: e.target.value })}
              autosize={{ minRows: 2, maxRows: 6 }} />

          </StyledDiv>
        </Section>
        <Footer>
          <Popconfirm
            title={
            <p>
                Вы действительно хотите отменить? <br />
                Все несохраненные изменения будут потеряны
              </p>
            }
            okText="Да"
            cancelText="Нет"
            onConfirm={this.goBack}>

            <Button>Отменить</Button>
          </Popconfirm>
          <Button type="primary" onClick={this.save}>
            Сохранить
          </Button>
        </Footer>
      </>);

  }
}

export default connect(
  (state, props) => ({
    filter: state.osagoCalculation.filter,
    unSelectedVehicleIds: state.osagoCalculation.unSelectedVehicleIds,
    selectedVehicleIds: state.osagoCalculation.selectedVehicleIds,
    freeVehicleOsagoCalculations: state.osagoCalculation.freeVehicleItems,
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }),
  {
    setSelectedVehicles,
    clearData,
    addFilterOsagoCalculation,
    addUnselectOsagoCalculation,
    setFilterOsagoCalculation,
    setUnselectOsagoCalculation,
    deleteOsagoCalculation
  }
)(OsagoCalculationsList);
